module.exports = __webpack_public_path__ + "static/Student1-b6090416b607f1216385ade37108798d.jpg";